export default {
  addbanner: {
    badge: "عرض محدود",
    cta: "تسوق الآن",

    title1: "خصم يصل إلى 50% على منتجات مميزة",
    desc1: "تسوق الخضروات الطازجة بأسعار مخفضة.",

    title2: "احصل على خصم 10% على الفواكه",
    desc2: "استمتع بفواكه طازجة مع خصومات موسمية.",

    title3: "خصم 75% على الخضروات العضوية",
    desc3: "اشترِ خضروات عضوية بأسعار لا تُضاهى.",
  },
};